import i18next from "i18next";
import { useConfirm } from "material-ui-confirm";

export function useNeoConfirm() {

	const baseConfirm = useConfirm();
	const alert = async (
		message: React.ReactNode,
		titleText = undefined as React.ReactNode,
		okBtnText = undefined as string,
	) => {
		try {
			await baseConfirm({
				description: message,
				title: titleText,
				confirmationButtonProps: { variant: "contained" },
				confirmationText: okBtnText || i18next.t('common.confirm'),
				hideCancelButton: true,
				dialogProps: { maxWidth: false, sx: { '& .MuiDialog-paper': { minWidth: 300, maxWidth: '90vw', width: 'auto' } } }
			});
		} catch (e) {
		}
	}

	const confirm = async (
		message: React.ReactNode,
		titleText = undefined as React.ReactNode,
		okBtnText = undefined as string,
		cancelBtnText = undefined as string
	) => {
		let yesNo = false;
		try {
			const result = await baseConfirm({
				description: message,
				title: titleText,
				confirmationButtonProps: { variant: "contained" },
				confirmationText: okBtnText || i18next.t('common.confirm'),
				cancellationText: cancelBtnText || i18next.t('common.cancel'),
			});

			yesNo = result.confirmed;
		} catch (e) {
			yesNo = false;
		}

		return yesNo;
	}

	return { alert, confirm };
}
